import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderSparkle"><Path d="M2.5 10.5V3.5H10L12 6.5H21.5V19.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.4 13H4.6L3.6 15.6L1 16.6V17.4L3.6 18.4L4.6 21H5.4L6.4 18.4L9 17.4V16.6L6.4 15.6L5.4 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderSparkle;
